import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

// Main columns configuration
export const homeSafetyCols = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({ viewModal, updateModal, deleteRecord });

  return {
    "Utility Shutoff Locations": [
      {
        title: "Gas",
        dataIndex: "Gas",
        key: "gas",
      },
      {
        title: "Water",
        dataIndex: "Water",
        key: "water",
      },
      {
        title: "Electricity",
        dataIndex: "Electricity", // Note: Matches the attribute name exactly
        key: "electricity",
      },
      actionColumn,
    ],
    "Emergency Equipment Locations": [
      {
        title: "Fire Extinguisher",
        dataIndex: "Fire Extinguisher",
        key: "fire extinguisher",
      },
      {
        title: "Smoke Detectors",
        dataIndex: "Smoke Detectors",
        key: "smoke detectors",
      },
      {
        title: "Carbon Monoxide Detectors",
        dataIndex: "Carbon Monoxide Detectors",
        key: "carbon monoxide detectors",
      },
      actionColumn,
    ],
    "Security System Details": [
      {
        title: "Company Name",
        dataIndex: "Company Name",
        key: "company name",
      },
      {
        title: "Sensor Locations",
        dataIndex: "Sensor Locations",
        key: "sensor locations",
      },
      {
        title: "Camera Locations",
        dataIndex: "Camera Locations",
        key: "camera locations",
      },
      {
        title: "Panic Button Locations",
        dataIndex: "Panic Button Locations",
        key: "panic button locations",
      },
      {
        title: "Keychain FOB Locations",
        dataIndex: "Keychain FOB Locations",
        key: "keychain fob locations",
      },
      {
        title: "Video Doorbell Locations",
        dataIndex: "Video Dorebell Locations",
        key: "video doorbell locations",
      },
      {
        title: "Floodlight Locations",
        dataIndex: "Floodlight Locations",
        key: "floodlight locations",
      },
      {
        title: "Smart Smoke Detector Locations",
        dataIndex: "Smart Smoke Detector Locations",
        key: "smart smoke detector locations",
      },
      {
        title: "Water Leak Detector Locations",
        dataIndex: "Water Leak Detector Locations",
        key: "water leak detector locations",
      },
      {
        title: "Other/Notes",
        dataIndex: "Other/Notes",
        key: "other/notes",
      },
      actionColumn,
    ],
  };
};
